import React, {Component} from "react";

class ProgressForm extends Component {
    render = () => {
        return <React.Fragment>
            <div className="progress">
                <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    aria-valuenow="75"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{
                        width: "100%"
                    }}>
                </div>
            </div>
            {this.props.text}
        </React.Fragment>
    }
}

export default ProgressForm;
